export const btbOrange = "#ed592b";

export const btbTextSecondary = "#b9b9b9";

export const blockHeaderColor = "rgba(255,79,15, 0.90)";